import React, {
    useCallback,
    useEffect,
    useState,
    useContext,
    useLayoutEffect,
    useMemo,
    useReducer,
    useSelctor,
    useDispatch,
    
} from 'react'
import { Container, Wrapper,Section } from './style'
import Sidebar from '../../components/CategorySidebar'
import ProductCard from '../../components/ProductCard'
import FeedbackCarousell from '../../components/FeedbackCarousell'
import {data} from '../../mock/productCard'

export default function index() {
    return (
        <Container>
            <Container flex>
                <Sidebar />
                <Wrapper>
                    {
                        data.map(({ discount, title, price, description }) => {
                            return (
                                <ProductCard discount={discount} title={title} price={price} description={description} />
                            )
                        })
                    }
                </Wrapper>
            </Container>
            <FeedbackCarousell />
            <Section>
                <h2>Section</h2>
                <Wrapper>
                    <ProductCard />
                    <ProductCard />
                    <ProductCard />
                    <ProductCard />
                </Wrapper>
            </Section>
        </Container>
    )
}
